import { Stack } from "@mui/material";
import { AddEditConfigurationDialog, AddEditLabel, ConfigurationsList, Filter, Header, ProductInformationDialog, Products, SelectedConfigurations } from "./components";
import { RootState } from "src/store";
import { connect } from "react-redux";
import { configuratorActions } from "./configurator-store";
import { useEffect } from "react";
import { useParams } from "react-router";

const mapStateToProps = (state: RootState) => ({
  activeTab: state.pageReducer.combinedConfiguratorReducer.configuratorReducer.activeTab,
  addEditConfigurationDialog: state.pageReducer.combinedConfiguratorReducer.addEditConfigurationDialogReducer.addEditConfigurationDialog,
  isProductInformationDialogOpen: state.pageReducer.combinedConfiguratorReducer.productInformationDialogReducer.isProductInformationDialogOpen,
  selectedConfigurations: state.pageReducer.combinedConfiguratorReducer.configuratorReducer.selectedConfigurations
});

const ownActions = {
  getConfigurationsRequest: configuratorActions.getConfigurationsRequest,
  getLabelsRequest: configuratorActions.getLabelsRequest
};

type Props = typeof ownActions & ReturnType<typeof mapStateToProps>;

const ConfiguratorBase = (props: Props) => {
  const { activeTab, addEditConfigurationDialog, isProductInformationDialogOpen, selectedConfigurations, getConfigurationsRequest, getLabelsRequest } = props;

  const { projectId = "" } = useParams<{ projectId: string }>();

  useEffect(() => {
    getConfigurationsRequest(projectId);
    getLabelsRequest(projectId);
  }, []);

  return (
    <Stack flex={1} overflow="auto">
      <Header />
      <Stack direction="row" flex={1} overflow="auto">
        <Stack flex={1} overflow="auto">
          <Stack px={5} py={2} flex={1} minWidth={0} overflow="auto" position="relative">
            {activeTab === "CONFIGURATIONS" && <ConfigurationsList />}
            {activeTab === "PRODUCTS" && <Products />}
            <AddEditLabel />
          </Stack>
          {selectedConfigurations.length > 0 && <SelectedConfigurations />}
        </Stack>
        <Filter />
      </Stack>
      {addEditConfigurationDialog && <AddEditConfigurationDialog />}
      {isProductInformationDialogOpen && <ProductInformationDialog />}
    </Stack>
  );
};

export const Configurator = connect(mapStateToProps, ownActions)(ConfiguratorBase);
